import { orient2d } from 'robust-predicates';

export default function pointInPolygon(
  point: number[],
  positions: Float32Array,
  startIndices: Uint32Array,
  polygonIndex: number,
): boolean | 0 {
  if (polygonIndex < 0 || polygonIndex + 1 >= startIndices.length) return false;

  const start = startIndices[polygonIndex];
  const end = startIndices[polygonIndex + 1];
  if (end - start < 4 || end * 2 > positions.length) return false;

  const firstCoordinateIndex = start * 2;
  const lastCoordinateIndex = (end - 1) * 2;
  if (positions[firstCoordinateIndex] !== positions[lastCoordinateIndex]
    || positions[firstCoordinateIndex + 1] !== positions[lastCoordinateIndex + 1]) return false;

  const x = point[0];
  const y = point[1];
  let crossings = 0;
  let previousX = positions[firstCoordinateIndex] - x;
  let previousY = positions[firstCoordinateIndex + 1] - y;

  for (let vertexIndex = start; vertexIndex < end - 1; vertexIndex += 1) {
    const nextCoordinateIndex = (vertexIndex + 1) * 2;
    const nextX = positions[nextCoordinateIndex] - x;
    const nextY = positions[nextCoordinateIndex + 1] - y;

    if (previousY === 0 && nextY === 0) {
      if ((nextX <= 0 && previousX >= 0) || (previousX <= 0 && nextX >= 0)) return 0;
    } else if ((nextY >= 0 && previousY <= 0) || (nextY <= 0 && previousY >= 0)) {
      const orientation = orient2d(previousX, nextX, previousY, nextY, 0, 0);
      if (orientation === 0) return 0;
      if ((orientation > 0 && nextY > 0 && previousY <= 0)
        || (orientation < 0 && nextY <= 0 && previousY > 0)) {
        crossings += 1;
      }
    }

    previousX = nextX;
    previousY = nextY;
  }

  return crossings % 2 !== 0;
}